import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import { getFlowType } from 'transfer/utils/url-utils'
import { CurrencyConversionSelectionBase } from './currencyConversionSelection'
import * as SendActions from '../actions/send'
import * as PayRequestActions from '../actions/pay-request'
import * as OverpanelActions from '../actions/overpanels'
import { trackImpression } from '../../lib/analytics/fpti'

class SendCurrencyConversionSelection extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    showAdditionalConversionInfo: PropTypes.bool.isRequired,
    currencyCode: PropTypes.string.isRequired,
    currencyDecimal: PropTypes.string.isRequired,
    selectedFundingOption: PropTypes.object.isRequired,
    isPurchase: PropTypes.bool.isRequired,
    overpanelVisible: PropTypes.bool.isRequired,
    userCountry: PropTypes.string.isRequired,
    ppCurrencyExchange: PropTypes.object.isRequired,
    preselectedFundingOption: PropTypes.object,
    flowIsPayRequest: PropTypes.bool,
    isFeeDisclaimerMessageDisabled: PropTypes.bool,
  }

  componentDidMount() {
    // impression tracking if overpanel shown (componenDidMount() gets called on close as well)
    if (this.props.overpanelVisible) {
      const fltp = this.props.isPurchase
        ? 'goodsandservices'
        : 'friendsandfamily'
      const pageGroup = 'main:consumer:p2p:transfer:currencyConversionOption'
      const pageName =
        'main:consumer:p2p:transfer:currencyConversionOption:::node'
      const extraData = { fltp }
      trackImpression(pageGroup, pageName, extraData)
    }
  }

  handleSubmit = conversionType => {
    const { preselectedFundingOption } = this.props
    this.closeCurrencyConversionOverpanel()
    if (this.props.flowIsPayRequest) {
      this.props.dispatch(
        PayRequestActions.fetchFundingOptions({ conversionType })
      )
    } else {
      this.props.dispatch(
        SendActions.fetchFundingOptions({
          conversionType,
          preselectedFundingOption,
        })
      )
    }
  }

  closeCurrencyConversionOverpanel = () => {
    this.props.dispatch(
      OverpanelActions.toggleCurrencyConversionOverpanel({ show: false })
    )
  }

  render() {
    return (
      <CurrencyConversionSelectionBase
        ppCurrencyExchange={this.props.ppCurrencyExchange}
        showAdditionalConversionInfo={this.props.showAdditionalConversionInfo}
        currencyCode={this.props.currencyCode}
        currencyDecimal={this.props.currencyDecimal}
        selectedFundingOption={this.props.selectedFundingOption}
        handleSubmit={this.handleSubmit}
        closeCurrencyConversionOverpanel={this.closeCurrencyConversionOverpanel}
        userCountry={this.props.userCountry}
        isFeeDisclaimerMessageDisabled={
          this.props.isFeeDisclaimerMessageDisabled
        }
      />
    )
  }
}

export default connect(
  ({ server, amount, transaction, overpanels, user, crossBorder }) => ({
    showAdditionalConversionInfo: server.showAdditionalConversionInfo,
    currencyCode: amount.currencyCode,
    currencyDecimal: amount.currencyDecimal,
    selectedFundingOption: transaction.selectedFundingOption,
    isPurchase: transaction.isPurchase,
    overpanelVisible: overpanels.currencyConversion,
    userCountry: user.country,
    ppCurrencyExchange: transaction.ppCurrencyExchange,
    preselectedFundingOption: transaction.preselectedFundingOption,
    flowIsPayRequest: getFlowType() === 'payRequest',
    isFeeDisclaimerMessageDisabled: crossBorder.disableFeeDisclaimerMessage,
  })
)(SendCurrencyConversionSelection)
